import {baseStyleProps as $2XVCg$baseStyleProps, passthroughStyle as $2XVCg$passthroughStyle, dimensionValue as $2XVCg$dimensionValue, useStyleProps as $2XVCg$useStyleProps, useDOMRef as $2XVCg$useDOMRef} from "@react-spectrum/utils";
import {filterDOMProps as $2XVCg$filterDOMProps} from "@react-aria/utils";
import $2XVCg$react, {forwardRef as $2XVCg$forwardRef} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $994c48bfb00b620b$var$gridStyleProps = {
    ...(0, $2XVCg$baseStyleProps),
    autoFlow: [
        'gridAutoFlow',
        (0, $2XVCg$passthroughStyle)
    ],
    autoColumns: [
        'gridAutoColumns',
        $994c48bfb00b620b$var$gridDimensionValue
    ],
    autoRows: [
        'gridAutoRows',
        $994c48bfb00b620b$var$gridDimensionValue
    ],
    areas: [
        'gridTemplateAreas',
        $994c48bfb00b620b$var$gridTemplateAreasValue
    ],
    columns: [
        'gridTemplateColumns',
        $994c48bfb00b620b$var$gridTemplateValue
    ],
    rows: [
        'gridTemplateRows',
        $994c48bfb00b620b$var$gridTemplateValue
    ],
    gap: [
        'gap',
        (0, $2XVCg$dimensionValue)
    ],
    rowGap: [
        'rowGap',
        (0, $2XVCg$dimensionValue)
    ],
    columnGap: [
        'columnGap',
        (0, $2XVCg$dimensionValue)
    ],
    justifyItems: [
        'justifyItems',
        (0, $2XVCg$passthroughStyle)
    ],
    justifyContent: [
        'justifyContent',
        (0, $2XVCg$passthroughStyle)
    ],
    alignItems: [
        'alignItems',
        (0, $2XVCg$passthroughStyle)
    ],
    alignContent: [
        'alignContent',
        (0, $2XVCg$passthroughStyle)
    ]
};
const $994c48bfb00b620b$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $2XVCg$forwardRef)(function Grid(props, ref) {
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $2XVCg$useStyleProps)(otherProps, $994c48bfb00b620b$var$gridStyleProps);
    if (styleProps.style) styleProps.style.display = 'grid'; // inline-grid?
    let domRef = (0, $2XVCg$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $2XVCg$react).createElement("div", {
        ...(0, $2XVCg$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
});
function $994c48bfb00b620b$export$76d90c956114f2c2(count, repeat) {
    return `repeat(${count}, ${$994c48bfb00b620b$var$gridTemplateValue(repeat)})`;
}
function $994c48bfb00b620b$export$9c1b655deaca4988(min, max) {
    return `minmax(${$994c48bfb00b620b$var$gridDimensionValue(min)}, ${$994c48bfb00b620b$var$gridDimensionValue(max)})`;
}
function $994c48bfb00b620b$export$2f0b47b0911ce698(dimension) {
    return `fit-content(${$994c48bfb00b620b$var$gridDimensionValue(dimension)})`;
}
function $994c48bfb00b620b$var$gridTemplateAreasValue(value) {
    return value.map((v)=>`"${v}"`).join('\n');
}
function $994c48bfb00b620b$var$gridDimensionValue(value) {
    if (/^max-content|min-content|minmax|auto|fit-content|repeat|subgrid/.test(value)) return value;
    return (0, $2XVCg$dimensionValue)(value);
}
function $994c48bfb00b620b$var$gridTemplateValue(value) {
    if (Array.isArray(value)) return value.map($994c48bfb00b620b$var$gridDimensionValue).join(' ');
    return $994c48bfb00b620b$var$gridDimensionValue(value);
}


export {$994c48bfb00b620b$export$ef2184bd89960b14 as Grid, $994c48bfb00b620b$export$76d90c956114f2c2 as repeat, $994c48bfb00b620b$export$9c1b655deaca4988 as minmax, $994c48bfb00b620b$export$2f0b47b0911ce698 as fitContent};
//# sourceMappingURL=Grid.module.js.map
